import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import mayesha from '../images/mayesha.png';
import sani from '../images/sani.png';
import ashad from '../images/ashad.png';
import robot from '../images/robot.png';
import '../css/Home.css'; // Ensure the correct path to your CSS file


const Home = () => {
  const cardData = [
    {
      title: 'Card 1',
      text: 'This is the content of card 1.',
      link: 'https://example.com/card1',
    },
    {
      title: 'Card 2',
      text: 'This is the content of card 2.',
      link: 'https://example.com/card2',
    },
    {
      title: 'Card 3',
      text: 'This is the content of card 3.',
      link: 'https://example.com/card3',
    },
    {
      title: 'Card 4',
      text: 'This is the content of card 4.',
      link: 'https://example.com/card4',
    },
    {
      title: 'Card 5',
      text: 'This is the content of card 5.',
      link: 'https://example.com/card5',
    },
    {
      title: 'Card 6',
      text: 'This is the content of card 6.',
      link: 'https://example.com/card6',
    },
  ];

  return (
    <div>
      <div className="banner">
        <div className="banner-image">
          <img src={robot} alt="Robot" />
        </div>
        <div className="banner-text">
          <h1>Social Robot </h1>
          <p>A social robot is a specialized type of robot designed to interact and engage with humans in a social and emotional manner, often featuring human-like attributes and behaviors. These robots are being developed for various applications, including assisting with healthcare, education, and companionship for the elderly or individuals with special needs.</p>
        </div>
      </div>

      <div className="project-name-div">
        <h1>Title: Rupkotha: A Multifunctional robot for Interactive Storytelling with Advanced Features</h1> {/* Project Title */}

        <p>
          "Rupkotha is an advanced storytelling robot, reimagining narratives through interactive engagement. With AI-driven conversations, emotional responsiveness, lifelike expressions, and the integration of Natural Language Processing (NLP), it enriches storytelling, creating an immersive experience for all."
        </p>


      </div>




      {/* <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
        <ol className="carousel-indicators">
          <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
        </ol>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="d-block w-100" src="{sani}" alt="First slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="{ashad}" alt="Second slide" />
          </div>
          <div className="carousel-item">
            <img className="d-block w-100" src="{mayesha}" alt="Third slide" />
          </div>
        </div>
        <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>

      <Row>
        {cardData.map((card, index) => (
          <Col key={index} sm={6}>
            <Card>
              <Card.Body>
                <Card.Title>{card.title}</Card.Title>
                <Card.Text>{card.text}</Card.Text>
                <a href={card.link} className="btn btn-primary">
                  Go to Card
                </a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>  */}
    </div>
  );
};

export default Home;
